import './basicWrapper.css';

export default function BasicWrapper({ children }) {
    return <div className='basicWrapper'>{children}</div>;
}
